import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { getCurrentLangCode } from '../utils/language';

function getUploadText(texts, key, fallback) {
    const v = texts && texts[key];
    if (v === undefined || v === null || v === '') return fallback;
    return String(v).trim();
}

// { banks, selectedBank, onSelectBank } is a destructuring method to use the functions directly without using props.banks,..
export default function BankSelector({ banks, selectedBank, setSelectedBank, uiTexts }) {
    const lang = getCurrentLangCode();
    const bankList = Array.isArray(banks) ? banks : [];
    const labelText = getUploadText(
        uiTexts,
        'upload.bank_selector.label',
        lang === 'de'
            ? 'Auswahl Ihres momentanen Finanzinstituts'
            : (lang === 'pl'
                ? 'Wybierz swoją obecną instytucję finansową'
                : 'Select your current financial institution')
    );

    return (
        <div className="form-group mb-4 d-flex align-items-center justify-content-between" style={{
            height: 'auto', 
            paddingBottom: '8%', 
            margin: '0 auto'
          }}>
            <label className="text-primary" style={{ flex: "0 0 auto" }}>
                {labelText} <span className="text-danger">*</span>
            </label>
            <div style={{ flex: "1", maxWidth: "60%", position: 'relative', display: 'inline-block', width: '100%' }}>
                <select
                    className="form-control"
                    value={selectedBank}
                    onChange={(e) => setSelectedBank(e.target.value)}
                    disabled={bankList.length === 0}
                    style={{
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        paddingRight: '45px',
                        cursor: 'pointer',
                        width: '100%'
                    }}
                >
                    {bankList.length === 0 ? (
                        <option value="">
                            {lang === 'de'
                                ? 'Lade Banken…'
                                : (lang === 'pl' ? 'Ładowanie banków…' : 'Loading banks…')}
                        </option>
                    ) : (
                        bankList.map((bank) => (
                            <option key={bank.id} value={bank.name}>
                                {bank.name}
                            </option>
                        ))
                    )}
                </select>
                <ArrowDropDownIcon 
                    sx={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none',
                        color: '#666',
                        fontSize: '28px',
                        zIndex: 10
                    }}
                />
            </div>
        </div>
    )

}